import classNames from "classnames";
import styles from "./statics/styles/style-presets-scss";
const getStyles = (environment, isMobile) => classNames({
  [styles.liveSite]: environment === "liveSite",
  [styles.businessManager]: environment === "businessManager",
  [styles.mobile]: isMobile
});
export {
  getStyles
};
//# sourceMappingURL=get-styles.js.map
